export enum INTEGRATION_TYPE {
	'MY_CARRIER_PACKETS' = 'MY_CARRIER_PACKETS',
	'MCLEOD' = 'MCLEOD',
	'BLUE_YONDER' = 'BLUE_YONDER',
	'MERCURY_GATE' = 'MERCURY_GATE',
	'TAI' = 'TAI',
	'OMNIS' = 'OMNIS',
	'THREE_PL_SYSTEMS' = 'THREE_PL_SYSTEMS',
	'FMS' = 'FMS',
	'LOGISTICALLY' = 'LOGISTICALLY',
	'ALJEX' = 'ALJEX',
	'TURVO' = 'TURVO',
	'BROKER_PRO' = 'BROKER_PRO',
	'AMAZON_FREIGHT' = 'AMAZON_FREIGHT',
	'GREEN_SCREENS' = 'GREEN_SCREENS',
	'RMIS' = 'RMIS',
	'HIGHWAY' = 'HIGHWAY',
	'CUSTOM' = 'CUSTOM',
}
